import React from 'react'

import { TableStyle } from './style'

export const Table: React.FC = ({ children }) => {
  return (
    <TableStyle>
      <thead>
        <tr>
          <th>Cargo</th>
          <th>Área</th>
          <th>Local</th>
          <th>Modalidade</th>
          <th></th>
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </TableStyle>
  )
}
